import styled from 'styled-components';

const VendorPlanFormStyled = styled.form`
    display: flex;
`;

export { VendorPlanFormStyled };
